import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import { useState } from 'react'

type RenderedSteps = { [key: string]: boolean }

type UseRenderedStepsParams = {
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
}

const useRenderedSteps = ({ steps }: UseRenderedStepsParams) => {
  const [renderedSteps, setRenderedSteps] = useState<RenderedSteps>(
    steps.reduce<RenderedSteps>((acc, step) => ({ [step.id]: false, ...acc }), {})
  )

  const setStepAsRendered = (stepId: string) => setRenderedSteps(state => ({ ...state, [stepId]: true }))

  return { renderedSteps, setStepAsRendered }
}

export default useRenderedSteps
